import React from "react"
import { Icon, Image, useColorMode } from "@chakra-ui/react"

// 貼上 svg 然後把 svg tag 改成 Icon，然後
// Icon 加上 {...props}
// fill="currentColor"

export const PerpCoin = (props: any) => {
    return (
        <Icon width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M12 2.75C6.89137 2.75 2.75 6.89137 2.75 12C2.75 17.1086 6.89137 21.25 12 21.25C17.1086 21.25 21.25 17.1086 21.25 12C21.25 6.89137 17.1086 2.75 12 2.75ZM1.25 12C1.25 6.06294 6.06294 1.25 12 1.25C17.9371 1.25 22.75 6.06294 22.75 12C22.75 17.9371 17.9371 22.75 12 22.75C6.06294 22.75 1.25 17.9371 1.25 12ZM9.77126 7.2715C10.2518 6.82221 10.9982 6.82221 11.4787 7.2715L13.375 9.04463L13.8963 8.55722C14.3768 8.10792 15.1232 8.10792 15.6037 8.55722L17.6217 10.4441C18.15 10.9381 18.15 11.7761 17.6217 12.2702L12.8537 16.7285C12.3732 17.1778 11.6268 17.1778 11.1463 16.7285L6.37833 12.2702C5.84999 11.7761 5.84999 10.9381 6.37833 10.4441L9.77126 7.2715ZM12.2769 10.0714L10.625 8.5268L7.59811 11.3571L9.25 12.9018L12.2769 10.0714ZM10.3481 13.9286L12 15.4732L13.6519 13.9286L12 12.3839L10.3481 13.9286ZM13.0981 11.3571L14.75 12.9018L16.4019 11.3571L14.75 9.81251L13.0981 11.3571Z"
                fill="currentColor"
            />
        </Icon>
    )
}

export const PerpCoinFill = (props: any) => {
    return (
        <Icon width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path d="M10.625 8.5268L12.2769 10.0714L9.25 12.9018L7.59811 11.3571L10.625 8.5268Z" fill="currentColor" />
            <path d="M12 15.4732L10.3481 13.9286L12 12.3839L13.6519 13.9286L12 15.4732Z" fill="currentColor" />
            <path d="M14.75 12.9018L13.0981 11.3571L14.75 9.81252L16.4019 11.3571L14.75 12.9018Z" fill="currentColor" />
            <path
                d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM11.4787 7.2715L13.375 9.04463L13.8963 8.55722C14.3768 8.10792 15.1232 8.10792 15.6037 8.55722L17.6217 10.4441C18.15 10.9381 18.15 11.7761 17.6217 12.2702L12.8537 16.7285C12.3732 17.1778 11.6268 17.1778 11.1463 16.7285L6.37833 12.2702C5.84999 11.7761 5.84998 10.9381 6.37833 10.4441L9.77126 7.2715C10.2518 6.82221 10.9982 6.82221 11.4787 7.2715Z"
                fill="currentColor"
            />
        </Icon>
    )
}

export const PerpSymbol = (props: any) => {
    return (
        <Icon width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M8.0756 4.48525C9.14478 3.4379 10.8552 3.4379 11.9244 4.48525L14.6667 7.17156L15.0756 6.77097C16.1448 5.72361 17.8552 5.72361 18.9244 6.77097L21.0903 8.89264C22.1911 9.97099 22.1911 11.7433 21.0903 12.8216L14.2577 19.5147C13.1886 20.5621 11.4781 20.5621 10.4089 19.5147L3.57639 12.8216C2.47558 11.7433 2.47558 9.97099 3.57639 8.89264L8.0756 4.48525ZM13.2376 8.57142L10.5248 5.91397C10.2332 5.62833 9.76676 5.62833 9.47516 5.91397L4.97595 10.3214C4.67573 10.6155 4.67573 11.0988 4.97595 11.3929L7.66667 14.0287L13.2376 8.57142ZM9.09569 15.4286L11.8085 18.086C12.1001 18.3716 12.5666 18.3716 12.8582 18.086L15.571 15.4286L12.3333 12.257L9.09569 15.4286ZM13.7624 10.8571L17 14.0287L19.6907 11.3929C19.9909 11.0988 19.9909 10.6155 19.6907 10.3214L17.5248 8.19968C17.2332 7.91404 16.7668 7.91404 16.4752 8.19968L13.7624 10.8571Z"
                fill="currentColor"
            />
        </Icon>
    )
}

export const Reward = (props: any) => {
    return (
        <Icon width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M13.6565 18.4783C14.0071 19.0916 14.484 19.6235 15.0516 20.0386C13.8339 20.6536 12.4574 21 11 21C6.02944 21 2 16.9706 2 12C2 7.02944 6.02944 3 11 3C15.7716 3 19.6758 6.71325 19.9808 11.4077C19.3734 11.1454 18.7037 11 18 11C17.9763 11 17.9527 11.0002 17.9292 11.0005C17.4442 7.60796 14.5266 5 11 5C7.13401 5 4 8.13401 4 12C4 15.866 7.13401 19 11 19C11.9403 19 12.8373 18.8146 13.6565 18.4783Z"
                fill="currentColor"
            />
            <path
                d="M18 19C19.6569 19 21 17.6569 21 16C21 14.3431 19.6569 13 18 13C16.3431 13 15 14.3431 15 16C15 17.6569 16.3431 19 18 19ZM18 21C15.2386 21 13 18.7614 13 16C13 13.2386 15.2386 11 18 11C20.7614 11 23 13.2386 23 16C23 18.7614 20.7614 21 18 21Z"
                fill="currentColor"
            />
            <path d="M14 11.5H8V9.5H14V11.5Z" fill="currentColor" />
            <path d="M12 14.5H8V12.5H12V14.5Z" fill="currentColor" />
        </Icon>
    )
}

export const RewardFill = (props: any) => {
    return (
        <Icon width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M15.0516 20.0386C13.8339 20.6536 12.4574 21 11 21C6.02944 21 2 16.9706 2 12C2 7.02944 6.02944 3 11 3C15.7716 3 19.6758 6.71325 19.9808 11.4077C21.757 12.1749 23 13.9423 23 16C23 18.7614 20.7614 21 18 21C16.8975 21 15.8783 20.6431 15.0516 20.0386ZM14 11.5V9.5H8V11.5H14ZM8 14.5H12V12.5H8V14.5ZM21 16C21 14.3431 19.6569 13 18 13C16.3431 13 15 14.3431 15 16C15 17.6569 16.3431 19 18 19C19.6569 19 21 17.6569 21 16Z"
                fill="currentColor"
            />
        </Icon>
    )
}

export const Wallet = (props: any) => {
    return (
        <Icon width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M20 7V5C20 3.897 19.103 3 18 3H5C3.346 3 2 4.346 2 6V18C2 20.201 3.794 21 5 21H20C21.103 21 22 20.103 22 19V9C22 7.897 21.103 7 20 7ZM5 5H18V7H5C4.448 7 4 6.551 4 6C4 5.449 4.448 5 5 5ZM20 19H5.012C4.55 18.988 4 18.805 4 18V8.815C4.314 8.928 4.647 9 5 9H20V19Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M14 15V17H16V15H18V13H16V11H14V13H12V15H14Z"
                fill="currentColor"
            />
        </Icon>
    )
}

export const WalletFill = (props: any) => {
    return (
        <Icon width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M18 3C19.103 3 20 3.897 20 5V7C21.103 7 22 7.897 22 9V19C22 20.103 21.103 21 20 21H5C3.794 21 2 20.201 2 18V6C2 4.346 3.346 3 5 3H18ZM18 5H5C4.448 5 4 5.449 4 6C4 6.551 4.448 7 5 7H18V5ZM14 17H16V15H18V13H16V11H14V13H12V15H14V17Z"
                fill="currentColor"
            />
        </Icon>
    )
}

export const CoinStackFilled = (props: any) => {
    return (
        <Icon
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="currentColor"
            {...props}
        >
            <path d="M12,10c3.976,0,8-1.374,8-4s-4.024-4-8-4S4,3.374,4,6S8.024,10,12,10z"></path>
            <path d="M4,10c0,2.626,4.024,4,8,4s8-1.374,8-4V8c0,2.626-4.024,4-8,4s-8-1.374-8-4V10z"></path>
            <path d="M4,14c0,2.626,4.024,4,8,4s8-1.374,8-4v-2c0,2.626-4.024,4-8,4s-8-1.374-8-4V14z"></path>
            <path d="M4,18c0,2.626,4.024,4,8,4s8-1.374,8-4v-2c0,2.626-4.024,4-8,4s-8-1.374-8-4V18z"></path>
        </Icon>
    )
}

export const CoinStack = (props: any) => {
    return (
        <Icon
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="currentColor"
            {...props}
        >
            <path d="M12,22c3.976,0,8-1.374,8-4v-4v-4V6c0-2.626-4.024-4-8-4S4,3.374,4,6v4v4v4C4,20.626,8.024,22,12,22z M12,20 c-3.722,0-6-1.295-6-2v-1.268C7.541,17.57,9.777,18,12,18s4.459-0.43,6-1.268V18C18,18.705,15.722,20,12,20z M12,4 c3.722,0,6,1.295,6,2s-2.278,2-6,2S6,6.705,6,6S8.278,4,12,4z M6,8.732C7.541,9.57,9.777,10,12,10s4.459-0.43,6-1.268V10 c0,0.705-2.278,2-6,2s-6-1.295-6-2V8.732z M6,12.732C7.541,13.57,9.777,14,12,14s4.459-0.43,6-1.268V14c0,0.705-2.278,2-6,2 s-6-1.295-6-2V12.732z"></path>
        </Icon>
    )
}

export const Xmark = (props: any) => {
    return (
        <Icon width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M5.1452 17.1983C4.71453 17.629 4.70574 18.3936 5.15398 18.8419C5.61102 19.2901 6.37566 19.2813 6.79754 18.8594L12.0007 13.6563L17.195 18.8507C17.6345 19.2901 18.3903 19.2901 18.8386 18.8419C19.2868 18.3848 19.2868 17.6378 18.8473 17.1983L13.653 12.004L18.8473 6.80085C19.2868 6.3614 19.2956 5.60554 18.8386 5.1573C18.3903 4.70905 17.6345 4.70905 17.195 5.14851L12.0007 10.3428L6.79754 5.14851C6.37566 4.71784 5.60223 4.70026 5.15398 5.1573C4.70574 5.60554 4.71453 6.37898 5.1452 6.80085L10.3395 12.004L5.1452 17.1983Z"
                fill="currentColor"
            />
        </Icon>
    )
}

export const Logo = (props: any) => {
    const { colorMode } = useColorMode()
    const logoColor = () => {
        if (props.always) {
            return props.always.toString()
        } else {
            return colorMode
        }
    }
    return <Image {...props} border="none" src={logoColor() === "light" ? "img/logo-color.svg" : "img/logo-bw.svg"} />
}

export const USDC = (props: any) => {
    return (
        <Icon width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M12 21.932C17.4853 21.932 21.932 17.4853 21.932 12C21.932 6.5147 17.4853 2.06799 12 2.06799C6.5147 2.06799 2.06799 6.5147 2.06799 12C2.06799 17.4853 6.5147 21.932 12 21.932Z"
                fill="#2775CA"
            />
            <path
                d="M10.136 18.908C10.136 19.14 9.948 19.272 9.732 19.204C6.724 18.24 4.552 15.428 4.552 12.1C4.552 8.78004 6.724 5.96404 9.736 5.00004C9.96 4.93204 10.14 5.06404 10.14 5.29604V5.87604C10.14 6.03204 10.024 6.20804 9.876 6.26404C7.492 7.14004 5.796 9.42804 5.796 12.1C5.796 14.776 7.496 17.06 9.876 17.928C10.024 17.984 10.14 18.16 10.14 18.316V18.908H10.136Z"
                fill="white"
            />
            <path
                d="M12.62 16.756C12.62 16.928 12.48 17.068 12.308 17.068H11.688C11.516 17.068 11.376 16.928 11.376 16.756V15.78C10.02 15.592 9.35999 14.84 9.17999 13.8C9.14799 13.62 9.28799 13.468 9.46799 13.468H10.176C10.324 13.468 10.448 13.576 10.48 13.716C10.612 14.328 10.968 14.804 12.056 14.804C12.856 14.804 13.428 14.352 13.428 13.688C13.428 13.02 13.096 12.764 11.916 12.572C10.176 12.34 9.35599 11.812 9.35599 10.452C9.35599 9.40399 10.156 8.57999 11.38 8.41199V7.44799C11.38 7.27599 11.52 7.13599 11.692 7.13599H12.312C12.484 7.13599 12.624 7.27599 12.624 7.44799V8.43199C13.624 8.61199 14.26 9.17599 14.472 10.124C14.512 10.304 14.372 10.464 14.184 10.464H13.532C13.392 10.464 13.276 10.372 13.236 10.24C13.056 9.64399 12.632 9.37999 11.884 9.37999C11.06 9.37999 10.636 9.77599 10.636 10.336C10.636 10.924 10.876 11.22 12.14 11.4C13.848 11.632 14.732 12.12 14.732 13.572C14.732 14.672 13.908 15.568 12.628 15.768V16.76H12.62V16.756Z"
                fill="white"
            />
            <path
                d="M13.86 18.904C13.86 19.136 14.04 19.268 14.264 19.2C17.276 18.24 19.448 15.428 19.448 12.1C19.448 8.77997 17.276 5.96397 14.264 5.01597C14.048 4.94797 13.86 5.07997 13.86 5.31197V5.89197C13.86 6.04797 13.976 6.22397 14.124 6.27997C16.504 7.14797 18.204 9.43197 18.204 12.108C18.204 14.776 16.5 17.068 14.124 17.936C13.96 17.992 13.86 18.152 13.86 18.324V18.904Z"
                fill="white"
            />
        </Icon>
    )
}

export const StakeIcon = (props: any) => (
    <Icon viewBox="0 0 55 57" w={55} h={57} {...props}>
        <svg width="55" height="57" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M9.09375 32.1953H22.7344V45.8359C22.7344 47.5469 24.1406 48.9531 25.8516 48.9531C27.5625 48.9531 28.9688 47.5469 28.9688 45.8359V32.1953H42.6094C44.3203 32.1953 45.7266 30.8125 45.7266 29.0781C45.7266 27.3672 44.3203 25.9609 42.6094 25.9609H28.9688V12.3203C28.9688 10.6094 27.5625 9.20312 25.8516 9.20312C24.1406 9.20312 22.7344 10.6094 22.7344 12.3203V25.9609H9.09375C7.38281 25.9609 5.97656 27.3672 5.97656 29.0781C5.97656 30.8125 7.38281 32.1953 9.09375 32.1953Z"
                fill="#98989B"
            />
        </svg>
    </Icon>
)

export const UnStakeIcon = (props: any) => (
    <Icon viewBox="0 0 55 57" w={55} h={57} {...props}>
        <svg width="55" height="57" viewBox="0 0 55 57" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M9.04688 32.2188H42.5859C44.2266 32.2188 45.6562 30.8125 45.6562 29.1016C45.6562 27.4141 44.2266 25.9844 42.5859 25.9844H9.04688C7.45312 25.9844 5.97656 27.4141 5.97656 29.1016C5.97656 30.8125 7.45312 32.2188 9.04688 32.2188Z"
                fill="#98989B"
            />
        </svg>
    </Icon>
)

export const PerpStakingLogo = (props: any) => (
    <Icon w={69} h={18} viewBox="0 0 69 18">
        <svg width="69" height="18" viewBox="0 0 69 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6.87379 4.14563C7.49985 3.53235 8.50141 3.53235 9.12747 4.14563L10.6096 5.59754C11.2542 6.22896 11.2542 7.26674 10.6096 7.89816L8.02659 10.4285L9.87909 12.2432C10.232 12.5889 10.2379 13.1553 9.89213 13.5083C9.54639 13.8612 8.97999 13.867 8.62704 13.5213L4.1392 9.12504C3.49462 8.49361 3.49462 7.45584 4.1392 6.82441L6.87379 4.14563ZM6.74819 9.17617L9.2271 6.74785L8.00063 5.54641L5.52172 7.97473L6.74819 9.17617Z"
                fill="#D1D1D1"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10.631 5.37244C11.2571 4.75916 12.2586 4.75915 12.8847 5.37244L14.3669 6.82434C15.0114 7.45577 15.0114 8.49354 14.3669 9.12497L9.87902 13.5212C9.52607 13.867 8.95967 13.8611 8.61393 13.5082C8.26819 13.1552 8.27403 12.5888 8.62697 12.2431L10.4795 10.4284L9.14888 9.12497C8.50429 8.49354 8.50429 7.45577 9.14888 6.82434L10.631 5.37244ZM11.7579 9.1761L12.9843 7.97466L11.7579 6.77321L10.5314 7.97466L11.7579 9.1761Z"
                fill="#D1D1D1"
            />
            <path d="M10.531 7.97772L9.22816 6.74023L7.97852 7.96751L9.25045 9.23292L10.531 7.97772Z" fill="#D1D1D1" />
            <path
                d="M21.0747 12.6729C23.1157 12.6729 24.335 11.6631 24.335 10.0786V10.0732C24.335 8.82178 23.583 8.16113 21.9341 7.83887L21.1338 7.68311C20.2959 7.5166 19.9414 7.2749 19.9414 6.83447V6.8291C19.9414 6.36719 20.3604 6.05029 21.0693 6.05029C21.7837 6.05029 22.2671 6.37256 22.3477 6.85596L22.3584 6.92041H24.1846L24.1792 6.85596C24.061 5.48633 23.0029 4.50342 21.0586 4.50342C19.2754 4.50342 17.9863 5.48096 17.981 7.00098V7.00635C17.981 8.21484 18.6899 8.98828 20.3281 9.30518L21.1284 9.46094C22.0361 9.63818 22.3799 9.84229 22.3799 10.2773V10.2827C22.3799 10.7769 21.875 11.126 21.1069 11.126C20.312 11.126 19.7803 10.7822 19.7266 10.3042L19.7212 10.2559H17.8413L17.8467 10.3525C17.9272 11.792 19.1411 12.6729 21.0747 12.6729Z"
                fill="#D1D1D1"
            />
            <path d="M27.6382 12.4634H29.604V6.29736H31.8438V4.71289H25.4038V6.29736H27.6382V12.4634Z" fill="#D1D1D1" />
            <path
                d="M31.9351 12.4634H34.0029L34.481 10.7607H37.0107L37.4888 12.4634H39.5566L36.9517 4.71289H34.54L31.9351 12.4634ZM35.6948 6.4209H35.7969L36.6133 9.34277H34.8784L35.6948 6.4209Z"
                fill="#D1D1D1"
            />
            <path
                d="M40.8564 12.4634H42.8276V10.272L43.5098 9.40723L45.4648 12.4634H47.7798L44.9438 8.13428L47.624 4.71289H45.5078L42.9297 8.04297H42.8276V4.71289H40.8564V12.4634Z"
                fill="#D1D1D1"
            />
            <path d="M48.9561 12.4634H50.9272V4.71289H48.9561V12.4634Z" fill="#D1D1D1" />
            <path
                d="M52.7588 12.4634H54.6279V8.05908H54.7246L57.9688 12.4634H59.5317V4.71289H57.6626V9.07422H57.5659L54.3325 4.71289H52.7588V12.4634Z"
                fill="#D1D1D1"
            />
            <path
                d="M64.8169 12.6729C67.0083 12.6729 68.335 11.3677 68.335 9.23535V8.23633H65.0156V9.58984H66.4336L66.4282 9.71875C66.3745 10.5137 65.7568 11.04 64.8599 11.04C63.7319 11.04 63.0015 10.0947 63.0015 8.56396V8.55322C63.0015 7.04932 63.6621 6.13623 64.7632 6.13623C65.542 6.13623 66.1382 6.54443 66.3047 7.19434L66.3154 7.24268H68.2598L68.2544 7.18896C68.0557 5.60986 66.6538 4.50342 64.7632 4.50342C62.4375 4.50342 60.998 6.06104 60.998 8.57471V8.58545C60.998 11.1313 62.4321 12.6729 64.8169 12.6729Z"
                fill="#D1D1D1"
            />
        </svg>
    </Icon>
)
